import React, { useState, useEffect, useCallback } from 'react';
import './History.css';
import { getFileUploadHistory } from '../../services/fileTransferHistoryService';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import appInsightsLogger from '../../utils/appInsights.js';

const PAGE_SIZE = 10;

function History({ organizationId }) {
  const [page, setPage] = useState(1);
  const [uploads, setUploads] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchHistory = useCallback(async (currentPage, orgId) => {
    setLoading(true);
    
    appInsightsLogger.trackEvent('History_Page_Load', {
      component: 'History',
      organizationId: orgId,
      page: currentPage
    });

    try {
      const data = await getFileUploadHistory(orgId);
      const total = data.length;
      const pages = total > 0 ? Math.ceil(total / PAGE_SIZE) : 0;
      const paginated = data.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
      setUploads(paginated);
      setTotalPages(pages);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'History',
        organizationId: orgId
      });
      setUploads([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;
    
    const loadData = async () => {
      if (!isMounted) return;
      await fetchHistory(page, organizationId);
    };
    
    loadData();
      
    return () => { isMounted = false; };
  }, [page, organizationId, fetchHistory]);

  return (
    <div className="history-main">
      <div className="history-card">
        <h2 className="history-title">Upload History</h2>
        <table className="history-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th className="file-name">File Name</th>
              <th className="upload-date">Upload Date</th>
              <th className="status">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} className="loading-cell">
                  <div className="table-loading">
                    <LoadingSpinner size="medium" />
                  </div>
                </td>
              </tr>
            ) : uploads.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: '40px 20px' }}>No uploads found.</td>
              </tr>
            ) : (
              uploads.map((item, idx) => (
                <tr key={idx}>
                  <td>{(page - 1) * PAGE_SIZE + idx + 1}</td>
                  <td className="file-name">{item.fileName}</td>
                  <td className="upload-date">{item.createdDate ? new Date(item.createdDate).toLocaleDateString() + ' ' + new Date(item.createdDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}</td>
                  <td className="status">
                    {item.status === 'success' || item.status === 'Success' ? (
                      <span className="history-status success">✓ Success</span>
                    ) : (
                      <span className="history-status error">✗ Failed</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="history-pagination">
          <button
            className="history-page-btn"
            onClick={() => setPage(1)}
            disabled={page === 1 || loading}
          >
            First
          </button>
          <button
            className="history-page-btn"
            onClick={() => setPage(page - 1)}
            disabled={page === 1 || loading}
          >
            Previous
          </button>
          <span className="history-page-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="history-page-btn"
            onClick={() => setPage(page + 1)}
                      disabled={page === totalPages || uploads.length === 0 || loading}
          >
            Next
          </button>
          <button
            className="history-page-btn"
            onClick={() => setPage(totalPages)}
                      disabled={page === totalPages || uploads.length === 0 || loading}
          >
            Last
          </button>
        </div>
      </div>
    </div>
  );
}

export default History;